<div class="tile">
  @if (facade.derivativeKeyData$ | async; as data) {
    <ng-container *ngTemplateOutlet="dataArea; context: { data, type: 'key', visible: (facade.derivativeKeyDataVisible$ | async) }" />
  }
  @if (facade.derivativeBaseData$ | async; as data) {
    <ng-container *ngTemplateOutlet="dataArea; context: { data, type: 'base', visible: (facade.derivativeBaseDataVisible$ | async) }" />
  }
  @if (facade.derivativePayoutProfile$ | async; as data) {
    <ng-container
      *ngTemplateOutlet="dataArea; context: { data, type: 'payout', visible: (facade.derivativePayoutProfileVisible$ | async) }"
    />
  }
  <p class="mt-3 zero-text p-xsmall-reg disabled">{{ 'instrument-detail.derivative-data.hint' | transloco }}</p>
</div>

<ng-template #dataArea let-data="data" let-type="type" let-visible="visible">
  @if (data?.length) {
    <div class="row mt-3 mb-2" [attr.data-zid]="type + '-data-area'">
      <div class="col">
        <div
          class="d-flex align-content-center justify-content-between cursor-pointer no-select"
          (click)="facade.toggleDerivativeDataVisibility(type)"
        >
          <h5 class="zero-text default">
            {{ 'instrument-detail.derivative-data.' + type | transloco }}
            @if (type === 'payout') {
              <web-design-system-pill type="new" class="ml-2">
                {{ 'instrument-detail.derivative-data.newBadge' | transloco | uppercase }}
              </web-design-system-pill>
            }
          </h5>
          <web-design-system-icon name="chevron" [class.icon-rotate]="!visible" />
        </div>
        @if (type !== 'payout' || !visible) {
          <web-design-system-divider [attr.data-zid]="type + '-divider'" />
        }
      </div>
    </div>
    @if (visible) {
      @if (type === 'payout') {
        <instrument-details-derivative-data-payout-profile [payoutProfile]="data" [attr.data-zid]="type + '-data-area'" />
      } @else {
        @if (type === 'key') {
          @if (facade.derivativeTopData$ | async; as top) {
            @if (top.length) {
              <div class="row d-block d-md-none" [attr.data-zid]="type + '-top-data-area'">
                @for (field of top; track $index) {
                  <div class="col-12 col-lg-6">
                    <ng-container *ngTemplateOutlet="fieldItem; context: { field }" />
                  </div>
                }
              </div>
            }
          }
        }
        <div class="row">
          @for (field of data; track $index) {
            <div class="col-12 col-lg-6">
              <ng-container *ngTemplateOutlet="fieldItem; context: { field }" />
            </div>
          }
        </div>
      }
    }
  }
</ng-template>

<ng-template #fieldItem let-field="field">
  <div class="d-flex align-items-center justify-content-between">
    <div class="zero-text p-small-reg label">{{ field.name }}</div>
    <div class="zero-text p-small-bold default">
      @if (field.clipboardInsertable) {
        <web-design-system-copy-to-clipboard
          [label]="field.value"
          [hint]="'instrument-detail.derivative-data.copy' | transloco: { value: field.name }"
        />
      } @else {
        {{ field.value ? field.value : '&mdash;' }}
      }
    </div>
  </div>
  <web-design-system-divider />
</ng-template>
